<template>
    <div class="vehicules">
        <vehicule-filters @vehiculesUpdated="updateVehicules" :selected="multipleSelection" @update-filters="onUpdateFilters" ref="filtersComponent"></vehicule-filters>
        <div class="brand-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} marques</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="vehicules" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Nom Speedway / ID Speedway" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.name}} / {{scope.row.shop_id}}
                    </template>
                </el-table-column>
                <el-table-column label="Nom fournisseur / ref fournisseur" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.model}} /
                        <span v-if="scope.row.bihr_id">{{scope.row.bihr_id}}</span>
                        <span v-if="!scope.row.bihr_id">-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="year" label="Année" sortable="custom" width="90"></el-table-column>
                <el-table-column label="Marque" width="90">
                    <template slot-scope="scope">
                        {{scope.row.brand.name}}
                    </template>
                </el-table-column>
                <el-table-column prop="cylinder" label="Cylindrée" sortable="custom" width="110"></el-table-column>
                <el-table-column prop="activated" label="Actif" sortable="custom" width="90">
                    <template slot-scope="scope">
                        <span v-if="scope.row.activated">O</span>
                        <span v-else>N</span>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" width="90">
                    <template slot-scope="scope">
                        <a :href="'/catalog?q=vehicule:'+scope.row.id" v-if="scope.row.productsCount">
                            <i class="fe fe-book-open"></i>
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
export default {
    data() {
        return {
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            modal: {
                display: false,
                brand: {}
            }
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['vehicules/totalItems'];
        },
        vehicules() {
            return this.$store.getters['vehicules/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        }
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        this.$store.dispatch('app/setSearchMode', 'vehicules');
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'brand_id':
                    case 'manufacturer_id':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            parseInt(params[key]),
                            true
                        );
                        break;
                    case 'category_id':
                        if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => parseInt(v));
                        } else {
                            var value = [parseInt(params[key])];
                        }

                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    default:
                        if (params[key] == 'false') {
                            value = false;
                        } else if (params[key] == 'true') {
                            value = true;
                        } else {
                            value = null;
                        }
                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                }
            }
            this.params = params;
        }
        this.fetch();
    },

    methods: {
        handleSelectionChange(val) {
            this.$store.dispatch('vehicules/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            this.loading = true;
            return this.$store.dispatch('vehicules/fetch', params).then(() => {
                this.loading = false;
            });
        },

        updateVehiculeInList(id, data) {
            this.$store.dispatch('vehicules/updateInList', { id, data });
        },

        deleteVehiculeInList(id) {
            this.$store.dispatch('vehicules/removeInList', id);
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(vehicule) {
            this.modal.display = true;
            this.modal.vehicule = vehicule.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        onUpdateVehicule(vehicule) {
            this.updateVehiculeInList(vehicule.id, vehicule);
            this.$refs.filtersComponent.validFilters();
            this.closeModalEdit();
        },

        updateVehicules(vehicules) {
            this.$refs.multipleTable.clearSelection();
            vehicules.forEach(vehicule => {
                this.updateVehiculeInList(vehicule.id, vehicule);
            });
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.vehicules .vehicule-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        onDeleteVehicule(id) {
            this.deleteVehiculeInList(id);
            this.closeModalEdit();
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        }
    }
};
</script>
<style lang="scss">
.vehicules {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
}
</style>
